import {combineReducers} from 'redux'
import types from 'actions/types'

export const isUpdating = (state = false, action) => {
  switch (action.type) {
    case types.XERO_UPDATE_ACCOUNT_DATA_ATTEMPT:
      return true
    case types.XERO_UPDATE_ACCOUNT_DATA_SUCCESS:
      return false
    case types.XERO_UPDATE_ACCOUNT_DATA_FAILURE:
      return false
    default:
      return state
  }
}

export const xeroStatus = (state = null, action) => {
  switch (action.type) {
    case types.XERO_STATUS_SUCCESS:
      return action.data
    case types.XERO_UPDATE_ACCOUNT_DATA_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  isUpdating,
  xeroStatus,
})
